var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOl({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 7.002a1 1 0 100-2h-8a1 1 0 100 2h8zM16 11a1 1 0 100-2h-4a1 1 0 100 2h4zm4 4.002a1 1 0 100-2h-8a1 1 0 000 2h8zm-3 3a1 1 0 01-1 1h-4a1 1 0 110-2h4a1 1 0 011 1zM5.85 7.008v6.498c0 .137.004.256.011.357.008.102.022.194.041.276.078.011.157.02.235.023.082.004.168.006.258.006h.626v.92a30.807 30.807 0 00-1.078-.07 23.27 23.27 0 00-1.992.006c-.351.015-.722.037-1.113.064v-.92h.873a1.48 1.48 0 00.234-.03c.02-.07.035-.156.047-.257a3.39 3.39 0 00.018-.37v-5.49c0-.105-.004-.207-.012-.304a1.145 1.145 0 00-.627-.07l-.61.052-.052-.61c.203-.058.41-.114.621-.17.211-.054.422-.103.633-.146.21-.043.418-.078.621-.105.207-.027.402-.041.586-.041.191 0 .348.025.469.076.12.047.191.149.21.305zM9 15.002a1 1 0 100-2 1 1 0 000 2z"
  })));
}

export default SvgOl;